import styled, { css } from 'styled-components';

export const Wrapper = styled.button<{ $borderRadius?: boolean }>`
    ${({ $borderRadius }) => css`
        position: relative;
        display: inline-block;
        cursor: help;
        z-index: 1;
        background: none;
        border: none;
        padding: 0;

        ${$borderRadius &&
        css`
            border-radius: 5rem;
        `}
    `}
`;

export const Container = styled.div`
    display: inline-block;
    position: relative;
`;

export const Tip = styled.div<{ $isOpen: boolean; $position: { top: number; left: number } }>`
    ${({ theme, $isOpen, $position }) => css`
        position: absolute;
        left: ${$position.left}px;
        top: ${$position.top}px;
        transform: translateY(0.75rem);
        display: ${$isOpen ? 'block' : 'none'};
        visibility: ${$isOpen ? 'visible' : 'hidden'};
        background-color: ${theme.colors.secondary.tints[1].hex};
        color: ${theme.colors.accents[5].hex};
        max-width: 65vw;
        width: 12rem;
        border-radius: 0.4rem;
        padding: 0.5rem;
        margin: 0 0.2rem;

        @media ${theme.breakpoints.medium.media} {
            width: 15rem;
        }
    `}
`;

export const Text = styled.p`
    margin: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.2;
`;
